import { Component, OnInit, OnChanges, SimpleChanges, Input, ViewEncapsulation, Output, EventEmitter } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import {CdkDragDrop, moveItemInArray} from '@angular/cdk/drag-drop';
import { AddQuestionModalComponent } from 'src/app/components/add-question-modal/add-question-modal.component';
import { CreateCustomQuestionComponent } from 'src/app/components/create-custom-question/create-custom-question.component';
import { MetricIconService } from 'src/app/services/metrics/metrics-icons.service';
import { QuestionnaireService } from 'src/app/services/questionnaire/questionnaire.service';
import { WarningModalService } from 'src/app/services/warning-modal/warning-modal.service';
import { AlertBannerService, AlertType } from 'src/app/lib/alert-banner';
import { QuestionOptionsConstantService } from 'src/app/components/create-custom-question/options-constant.service';
import { PermissionsService } from 'src/app/services/permissions/permissions.service';
import { ConstantsService } from 'src/app/services/constants/constants.service';

@Component({
  selector: 'app-survey-blocks',
  templateUrl: './survey-blocks.component.pug',
  styleUrls: ['./survey-blocks.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false
})
export class SurveyBlocksComponent implements OnInit, OnChanges {
  @Input() questions:any = [];
  @Input() maxLimit = 0;
  @Input() type = 'exit';
  @Input() isToggled= true;
  @Input() noteToCandidateChange: boolean = false;
  @Input() noteToRefereeChange: boolean = false;
  @Input() minReferee = ConstantsService.DEFAULT_REFEREE_COUNT; // Default minimum referee count
  @Input() externalDisableAddButton = true;
  @Output() questionChange:EventEmitter<any> = new EventEmitter();
  @Output() toggleEvent = new EventEmitter<boolean>();
  optionalcommentstooltip = $localize`This question does not count towards the total questions limit.`
  options_map = QuestionOptionsConstantService.questionTypes;
  confirmationQuestion: any;
  addQuestionModal: BsModalRef = new BsModalRef();
  createCustomQuestionModal: BsModalRef = new BsModalRef();
  canManageRefSurvey = false;
  canManageExitSurvey = false;
  canManagePulseSurvey = false;
  canManageOwnRefSurvey = false;
  canManageOwnExitSurvey = false;
  canManageOwnPulseSurvey = false;
  canManage = false;
  ENT_10363_PULSE_RELAUNCH = false;

  constructor( private modalService: BsModalService,
               private metricIconService: MetricIconService,
               private questionnaireService:QuestionnaireService,
               private alertList: AlertBannerService,
               private modal: WarningModalService,
               private permissionsService: PermissionsService) { }

  ngOnInit(): void {
    this.canManageRefSurvey = this.permissionsService.hasPermission('can_manage_reference_surveys');
    this.canManageExitSurvey = this.permissionsService.hasPermission('can_manage_exit_surveys');
    this.canManagePulseSurvey = this.permissionsService.hasPermission('can_manage_pulse_surveys');
    this.canManageOwnRefSurvey = this.permissionsService.hasPermission('can_manage_own_reference_surveys');
    this.canManageOwnExitSurvey = this.permissionsService.hasPermission('can_manage_own_exit_surveys');
    this.canManageOwnPulseSurvey = this.permissionsService.hasPermission('can_manage_own_pulse_surveys');
    this.ENT_10363_PULSE_RELAUNCH = this.permissionsService.isFeatureActivated('ent-10363-pulse-relaunch');
    
    let survey_type = (this.type != 'pulse' && this.type != 'exit') ? 'reference' : this.type;
    if (survey_type == 'reference') {
      this.canManage = this.canManageRefSurvey || this.canManageOwnRefSurvey;
    }
    if (survey_type == 'exit') {
      this.canManage = this.canManageExitSurvey || this.canManageOwnExitSurvey;
    }
    if (survey_type == 'pulse') {
      this.canManage = this.canManagePulseSurvey || this.canManageOwnPulseSurvey;
    }

    if(this.type=='candidate'){
      this.questionnaireService.getConfirmationQuestion().subscribe(
        res=> {
          this.confirmationQuestion = res.data;
        },
        err => {
          this.alertList.append([{
            type: AlertType.DANGER,
            message: $localize`Oops! Something went wrong. Our developers have been notified. Feel free to try again.`,
            keepOnRouteChange: true
          }]);
        }
      )
    }
  }
  getMetricIcon(metric) {
    return this.metricIconService.getMetricIcon(metric);
  }
  reorder(event: CdkDragDrop<string[]>) {
    moveItemInArray(this.questions, event.previousIndex, event.currentIndex);
    this.questionChange.emit(this.questions);
  }

  checkRefereeType(type){
    return (type == 'employment' || type == 'academic' || type == 'character' || type == 'voluntary');
  }

  deleteQuestion(index){
    this.questions.splice(index, 1);
    this.questionChange.emit(this.questions);
  }
  addQuestion(){
    let initialState = {
        'previouslySelected': this.questions,
        'type': this.type,
        'canManage': this.canManage,
        'externalDisableAddButton': this.externalDisableAddButton
      }

    this.addQuestionModal = this.modalService.show(
      AddQuestionModalComponent,
      { class: 'modal-dialog-centered xl-popup' , initialState},
    )
    this.addQuestionModal.content.closeBtnName = 'Close';
    this.addQuestionModal.content.addClick.subscribe((res)=>{
      this.questions = this.questions.concat(res.data);
      this.questionChange.emit(this.questions);
    });
    this.addQuestionModal.content.helpClick.subscribe((res)=>{
      const styleClass = res ? 'modal-dialog-scrollable add-question-modal-help' : 'modal-dialog-scrollable add-question-modal'
      this.addQuestionModal.setClass(styleClass);
    })
    this.addQuestionModal.content.createClick.subscribe(res=>this.createQuestion(res));
    this.addQuestionModal.content.editQuestionClick.subscribe(res=>this.editQuestion(res));
    this.addQuestionModal.content.deleteQuestionClick.subscribe(res=>this.deleteQuestionFromLibrary(res));
    this.addQuestionModal.content.hideQuestionClick.subscribe(res=>this.hideQuestionFromLibrary(res));
  }

  updateAddQuestionModalDisableState(): void {
    if (this.addQuestionModal && this.addQuestionModal.content) {
      this.addQuestionModal.content.externalDisableAddButton = this.externalDisableAddButton;
    }
  }

  createQuestion(type){
    const initialState={type}
    let modalStylingClass = 'modal-dialog-scrollable create-question-modal';
    this.createCustomQuestionModal = this.modalService.show(
      CreateCustomQuestionComponent,
      { class: modalStylingClass, initialState, ignoreBackdropClick: true}
    )
    this.createCustomQuestionModal.content.closeBtnName = 'Close';
    this.createCustomQuestionModal.content.nextClick.subscribe(res=>{
      this.questionnaireService.postQuestion(res).subscribe(resData=>{
        this.questions = this.questions.concat([resData]);
        this.questionChange.emit(this.questions);
      },err=>{
        this.alertList.append([{
          type: AlertType.DANGER,
          message: $localize`Oops! Something went wrong. Our developers have been notified. Feel free to try again.`,
          keepOnRouteChange: true
        }]);
      })
    });
    this.createCustomQuestionModal.content.cancelClick.subscribe(()=>{
      this.addQuestion();
    });
  }

  editQuestion(question){
    const initialState={
      'selectedMetric': question.metric ? question.metric.id : -1 ,
      'questionText': question.question_text,
      'isEdit': true,
      'isInsights': question.is_measured,
      'options': question.options,
      'type': question.question_type,
      'responseType': question.response_type
    }
    this.createCustomQuestionModal = this.modalService.show(
      CreateCustomQuestionComponent,
      { class: 'modal-dialog-scrollable add-question-modal', initialState, ignoreBackdropClick: true}
    )
    this.createCustomQuestionModal.content.cancelClick.subscribe(res => {
        this.addQuestion();
      }
    )
    this.createCustomQuestionModal.content.closeBtnName = 'Close';
    this.createCustomQuestionModal.content.nextClick.subscribe(res=>{
      console.log(res);
      this.questionnaireService.editQuestion(question.id,res).subscribe(res=>{
        console.log(res);
        this.alertList.append([{
          type: AlertType.SUCCESS,
          message: $localize`Success! Question has been saved.`,
          keepOnRouteChange: true
        }]);
        this.addQuestion();
      },err=>{
        this.alertList.append([{
          type: AlertType.DANGER,
          message: $localize`Oops! Something went wrong. Our developers have been notified. Feel free to try again.`,
          keepOnRouteChange: true
        }]);
      })
    })
  }

  deleteQuestionFromLibrary(question){
    this.modal.confirm(
      $localize`Delete question?`,
      $localize`Are you sure you want to delete this question from your library?`,
      false, $localize`Cancel`, $localize`Yes`).subscribe(res=>{
      if(res){
        this.questionnaireService.deleteQuestion(question.id).subscribe(res=>{
          console.log(res);
          this.alertList.append([{
            type: AlertType.SUCCESS,
            message: $localize`Success! Question has been deleted.`,
            keepOnRouteChange: true
          }]);
          this.addQuestion();
        },err=>{
          this.alertList.append([{
            type: AlertType.DANGER,
            message: $localize`Oops! Something went wrong. Our developers have been notified. Feel free to try again.`,
            keepOnRouteChange: true
          }]);
          this.addQuestion();
        })
      } else {
        this.addQuestion();
      }
    })

  }
  hideQuestionFromLibrary(question){
    this.modal.confirm(
      $localize`Hide question?`,
      $localize`Are you sure you want to hide this question from your library?`,
      false, $localize`Cancel`, $localize`Yes`).subscribe(res=>{
      if(res){
        this.questionnaireService.hideQuestion(question.id).subscribe(res=>{
          this.alertList.append([{
            type: AlertType.SUCCESS,
            message: $localize`Success! Question has been hidden from library.`,
            keepOnRouteChange: true
          }]);
          this.addQuestion();
        },err=>{
          this.alertList.append([{
            type: AlertType.DANGER,
            message: $localize`Oops! Something went wrong. Our developers have been notified. Feel free to try again.`,
            keepOnRouteChange: true
          }]);
          this.addQuestion();
        })
      } else {
        this.addQuestion();
      }
    })
  }
  Toggle(){
    this.isToggled=!this.isToggled;
    this.toggleEvent.emit(this.isToggled)
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.ENT_10363_PULSE_RELAUNCH && (changes['externalDisableAddButton'] && !changes['externalDisableAddButton'].firstChange)) {
      this.updateAddQuestionModalDisableState();
    }
  }
}
